import { Actions } from '../../interfaces'
import { MaintenanceBackupType } from '@/entities/public'

import find from './find'

export const actions: Actions = {
  find,
}

export default {
  Model: { MaintenanceBackupType },
  actions: { [MaintenanceBackupType.name]: actions },
}
